import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";

interface IWeeklyTrainingTime {
  totalMinutes: number;
}

const WeeklyTrainingTime = ({ totalMinutes }: IWeeklyTrainingTime) => {
  const { i18n } = useI18n();

  const totalHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = Math.round(totalMinutes % 60);

  return (
    <Stack direction="row" alignItems="baseline" spacing={1}>
      <Typography variant="text3xl700" color="text.primary" textAlign="left">
        {totalHours}
      </Typography>
      <Typography variant="text1xl400" color="dsNeutral.v300">
        {i18n("hours-extra-short-capitalized")}
      </Typography>
      <Typography variant="text3xl700" color="text.primary" textAlign="left">
        {remainingMinutes}
      </Typography>
      <Typography variant="text1xl400" color="dsNeutral.v300">
        {i18n("minutes-extra-short-capitalized")}
      </Typography>
    </Stack>
  );
};

export default WeeklyTrainingTime;
